import { render, staticRenderFns } from "./login_bottom.vue?vue&type=template&id=fae352f6&scoped=true"
import script from "./login_bottom.vue?vue&type=script&lang=js"
export * from "./login_bottom.vue?vue&type=script&lang=js"
import style0 from "./login_bottom.vue?vue&type=style&index=0&id=fae352f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae352f6",
  null
  
)

export default component.exports